/* VELMAR PARIS — comportements des sections vlm-* (carrousels à onglets, texte SEO repliable, galerie produit « Voir plus de photos »). */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function initCarousel(root) {
    if (root.dataset.vlmInit) return;
    root.dataset.vlmInit = '1';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-vlm-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-vlm-panel]'));
    var prev = root.querySelector('[data-vlm-prev]');
    var next = root.querySelector('[data-vlm-next]');
    var all = root.querySelector('[data-vlm-all]');

    function activeTrack() {
      var p = panels.filter(function (x) { return !x.hidden; })[0] || root;
      return p.querySelector('[data-vlm-track]');
    }
    function update() {
      var t = activeTrack();
      if (!t || !prev || !next) return;
      var max = t.scrollWidth - t.clientWidth - 2;
      prev.disabled = t.scrollLeft <= 2;
      next.disabled = t.scrollLeft >= max;
      prev.parentElement.style.visibility = max <= 0 ? 'hidden' : '';
    }
    function step(dir) {
      var t = activeTrack();
      if (!t) return;
      var first = t.firstElementChild;
      var gap = parseFloat(getComputedStyle(t).columnGap) || 20;
      var w = first ? first.getBoundingClientRect().width + gap : t.clientWidth;
      var n = Math.max(1, Math.floor((t.clientWidth + gap) / w));
      t.scrollBy({ left: dir * w * n, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    Array.prototype.forEach.call(root.querySelectorAll('[data-vlm-track]'), function (t) {
      t.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    });
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t, j) {
          t.setAttribute('aria-selected', i === j ? 'true' : 'false');
          t.tabIndex = i === j ? 0 : -1;
        });
        panels.forEach(function (p, j) { p.hidden = i !== j; });
        if (all && tab.dataset.url) all.setAttribute('href', tab.dataset.url);
        var t = activeTrack();
        if (t) t.scrollLeft = 0;
        update();
      });
    });
    window.addEventListener('resize', update);
    update();
  }

  function initSeo(root) {
    var btn = root.querySelector('[data-vlm-seo-toggle]');
    var body = root.querySelector('[data-vlm-seo-body]');
    if (!btn || !body || btn.dataset.vlmInit) return;
    btn.dataset.vlmInit = '1';
    if (body.scrollHeight <= body.clientHeight + 4) {
      btn.hidden = true;
      body.classList.add('is-open');
      return;
    }
    btn.addEventListener('click', function () {
      var open = body.classList.toggle('is-open');
      btn.textContent = open ? btn.dataset.less : btn.dataset.more;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Galerie en grille : on replie au-delà de 6 visuels UNIQUEMENT si la galerie
     complète est nettement plus haute que la colonne d'achat (sinon trou blanc). */
  function initGallery() {
    if (!document.querySelector('.vlm-ph')) return;
    if (window.innerWidth <= 750) return;
    var info = document.querySelector('.product-section__product-info');
    Array.prototype.forEach.call(document.querySelectorAll('.product-media-gallery--grid'), function (g) {
      if (g.dataset.vlmInit) return;
      g.dataset.vlmInit = '1';
      var main = g.querySelector('.product-media-gallery-main-slider');
      if (!main) return;
      var slides = main.querySelectorAll('.splide__slide');
      var limit = 6;
      if (slides.length <= limit) return;
      var galH = main.getBoundingClientRect().height;
      var infoH = info ? info.getBoundingClientRect().height : 0;
      if (infoH && galH < infoH + 240) return;
      g.classList.add('vlm-gallery-collapsed');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'vlm vlm-btn vlm-btn--ghost vlm-btn--sm vlm-more-photos';
      b.textContent = 'Voir plus de photos (' + (slides.length - limit) + ')';
      b.addEventListener('click', function () {
        g.classList.remove('vlm-gallery-collapsed');
        b.remove();
      });
      main.parentNode.insertBefore(b, main.nextSibling);
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-vlm-carousel]'), initCarousel);
    Array.prototype.forEach.call(document.querySelectorAll('[data-vlm-seo]'), initSeo);
    initGallery();
  }

  ready(init);
  window.addEventListener('load', initGallery);
  document.addEventListener('shopify:section:load', init);
})();
